import React from 'react';
import { Row, Col } from 'react-bootstrap';
import className from 'classnames';
import Section from 'components/common/Section';
import CardService from './CardService';
import SectionHeader from './SectionHeader';
import { useTranslation } from 'react-i18next';

const serviceKeys = [
  { media: { icon: 'chart-line', color: 'primary', className: 'fs-4' }, titleKey: 'FEATURE_DASHBOARD_TITLE', descKey: 'FEATURE_DASHBOARD_DESC' },
  { media: { icon: 'dollar-sign', color: 'success', className: 'fs-4' }, titleKey: 'FEATURE_SALES_TITLE', descKey: 'FEATURE_SALES_DESC' },
  { media: { icon: 'comments', color: 'info', className: 'fs-4' }, titleKey: 'FEATURE_MESSAGES_TITLE', descKey: 'FEATURE_MESSAGES_DESC' },
  { media: { icon: 'box', color: 'warning', className: 'fs-4' }, titleKey: 'FEATURE_STOCK_TITLE', descKey: 'FEATURE_STOCK_DESC' },
  { media: { icon: 'users', color: 'danger', className: 'fs-4' }, titleKey: 'FEATURE_TEAM_TITLE', descKey: 'FEATURE_TEAM_DESC' },
  { media: { icon: 'plug', color: 'secondary', className: 'fs-4' }, titleKey: 'FEATURE_INTEGRATIONS_TITLE', descKey: 'FEATURE_INTEGRATIONS_DESC' }
];

const Services = () => {
  const { t } = useTranslation();

  return (
    <Section bg="light" className="text-center" id="features">
      <SectionHeader
        title={t('LANDING.FEATURES_TITLE')}
        subtitle={t('LANDING.FEATURES_SUBTITLE')}
      />
      <Row className="mt-6">
        {serviceKeys.map((service, index) => (
          <Col
            lg={4}
            className={className({ 'mt-6 mt-lg-0': index > 2 }, 'mb-4')}
            key={index}
          >
            <CardService
              media={service.media}
              title={t(`LANDING.${service.titleKey}`)}
              description={t(`LANDING.${service.descKey}`)}
            />
          </Col>
        ))}
      </Row>
    </Section>
  );
};

export default Services;
